<template>
    <div>
    	<div>
	        <Row class="expand-row">
	        	<!-- 访问秘钥 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.AccessKey')}}: </span>
	                <span class="expand-value">{{ row.accessKeyId }}</span>
	            </Col>
	            <!-- 事件源 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.EventSource')}}: </span>
	                <span class="expand-value">{{ row.eventSource }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 地域 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.district')}}: </span>
	                <span class="expand-value">{{ row.acsRegion }}</span>
	            </Col>
	            <!-- 事件时间 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.eventTime')}}: </span>
	                <span class="expand-value">{{ row.eventTime }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 错误代码 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.ErrorCode')}}: </span>
	                <span class="expand-value">{{ row.errorCode }}</span>
	            </Col>
	            <!-- 请求ID -->
	            <Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.RequestID')}}: </span>
	                <span class="expand-value">{{ row.requestId }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 事件ID -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.EventID')}}: </span>
	                <span class="expand-value">{{ row.eventId }}</span>
	            </Col>
	            <!-- 源IP地址 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.SourceIPAddress')}}: </span>
	                <span class="expand-value">{{ row.sourceIpAddress }}</span>
	            </Col>
	        </Row>
	        <Row style="padding-left: 17px;">
	        	<!-- 事件名称 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.EventName')}}: </span>
	                <span class="expand-value">{{ row.eventName }}</span>
	            </Col>
	            <!-- 用户名 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('ActionTrailSecurity.userName')}}: </span>
	                <span class="expand-value">{{ row.userName }}</span>
	            </Col>
	        </Row>
        </div>
        <div class="resource-main">
        	<!-- 相关资源 -->
        	 <Row style="margin-top: 20px;margin-bottom: 20px;">
	        	<Col span="12">
	                <span class="expand-key" style="font-size: 13px;font-weight: 600;">{{$t('ActionTrailSecurity.RelatedResources')}}</span>
	            </Col>
	        </Row>
	        <table class="resource-table">
	            <thead>
	                <tr>
	                	<!-- 资源类型 -->
	                	<th>{{$t('ActionTrailSecurity.resourceType')}}</th>
	                	<!-- 资源名称 -->
	                	<th>{{$t('ActionTrailSecurity.resourceName')}}</th>
	                </tr>
	            </thead>
	            <tbody v-if="row.actionTrailReferencedResources.length!=0">
	            	<tr v-for="item in row.actionTrailReferencedResources">
	            		<td>{{item.resourceType}}</td>
	            		<td v-for="list in item.resourceName">{{list}}</td>
	            	</tr>
	            </tbody>
	            <tbody v-else-if="row.actionTrailReferencedResources.length===0">
	            	<tr>
	            		<td style="width: 100%;text-align: right;">{{$t('common.noData')}}</td>
	            		<td></td>
	            	</tr>
	            </tbody>
	        </table>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
    .resource-main
    {
		width: 97.3%;
		margin:auto;
		margin-top: 20px;
		border-top: 1px solid #dcdee2;
    }
    .resource-table
    {
    	width: 100%;
    	border-top: 1px solid #dfe1e5;
    	border-left: 1px solid #dfe1e5;
    	border-right: 1px solid #dfe1e5;
    }
    .resource-table th
    {
    	padding-left: 17px;
    }
    .resource-table td
    {
    	padding-left: 17px;
    }
</style>


// WEBPACK FOOTER //
// src/components/monitor/logs/security/TableExpand.vue